export enum ReceptionSearchActiveKinds {
  NotSpecificated = 1,
  Activated = 2,
  Inactivated = 3,
}
